import { faPencil, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import Swal from "sweetalert2";
// import 'LeaveManagement/LeaveManagement.css'; // Adjust the path as necessary
const LeaveManagementApplyList = ({
  balanceLeaves,
  applyLeave,
  managePage,
  addPage,
  deletePage,
}) => {
  const [delId, setDelId] = useState(0);

  const handleDelete = (id) => {
    setDelId(id);
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Perform the delete action here
        document.getElementById(`fd${id}`).submit();
      } else {
        Swal.fire("Cancelled", "Your record is safe :)", "error");
      }
    });
  };

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <div className="row">
            <div className="col-md-12">
              <div className="panel-heading border-0">
                <h4 className="panel-title pull-left">Balance Leave</h4>
              </div>
            </div>
            <div className="col-md-12">
              {balanceLeaves && balanceLeaves.length > 0 ? (
                <div className="table-responsive">
                  <table className="table m-b-0">
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>#</th>
                        <th>Type</th>
                        <th>Description</th>
                        <th>Yearly Leave</th>
                        <th>Monthly Leave</th>
                        <th>Is Loss Of Pay</th>
                        <th>Used Days</th>
                        <th>Remaining Days</th>
                      </tr>
                    </thead>
                    <tbody>
                      {balanceLeaves.map((leave, index) => (
                        <tr key={index}>
                          <td
                            style={{
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td>{leave.type}</td>
                          <td>{leave.description}</td>
                          <td>{leave.yearly_leave}</td>
                          <td>{leave.monthly_leave}</td>
                          <td>{leave.is_loss_of_pay === 0 ? "No" : "Yes"}</td>
                          <td>{leave.used_days}</td>
                          <td>{leave.remaining_days}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div>No records found.</div>
              )}
            </div>
          </div>
        </div>
        <div className="panel panel-default with-rounded-corner with-shadow">
          <div className="row">
            <div className="col-md-12">
              <div className="panel-heading border-0">
                <h4 className="panel-title pull-left">{managePage}</h4>
                {addPage && (
                  <button
                    className="btn btn-default btn-sm pull-right"
                    onClick={() => (window.location.href = addPage)}
                  >
                    <FontAwesomeIcon icon={faPlus} /> Apply Leave
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {applyLeave && applyLeave.length > 0 ? (
                <div className="table-responsive">
                  <table className="table m-b-0">
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>#</th>
                        <th>User</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Leave Type</th>
                        <th>Reason</th>
                        <th>Status</th>
                        <th style={{ width: "1%" }} colSpan="2">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {applyLeave.map((leave, index) => (
                        <tr key={index}>
                          <td
                            style={{
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td>{leave.user_fullname}</td>
                          <td>{leave.start_date}</td>
                          <td>{leave.end_date}</td>
                          <td>{leave.type}</td>
                          <td>{leave.reason}</td>
                          <td>{leave.status}</td>
                          <td>
                            {leave.status === "Pending" && (
                              <a
                                href={`${addPage}${leave.id}`}
                                className="btn btn-warning btn-xs"
                                style={{ float: "left" }}
                              >
                                <FontAwesomeIcon icon={faPencil} />
                              </a>
                            )}
                          </td>
                          <td>
                            {leave.status === "Pending" && (
                              <form
                                id={`fd${leave.id}`}
                                action={`${deletePage}${leave.id}`}
                                method="POST"
                              >
                                <button
                                  type="button"
                                  className="cancel btn btn-danger btn-xs"
                                  style={{ float: "left" }}
                                  onClick={() => handleDelete(leave.id)}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </button>
                              </form>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div>No records found.</div>
              )}
            </div>
          </div>
        </div>
      </div>
      <input type="hidden" name="delid" id="delid" value={delId} />
      <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
        <i className="ti-arrow-up"></i>
      </a>
    </div>
  );
};

export default LeaveManagementApplyList;
